'use client'

import Button from '@lyra/core/components/Button'
import ButtonGroup from '@lyra/core/components/ButtonGroup'
import { DropdownContext } from '@lyra/core/components/Dropdown'
import Section from '@lyra/core/components/Section'
import { InstrumentType } from '@lyra/web/constants/instruments'
import { CurrencyId } from '@lyra/web/constants/tokens'
import { getInstrumentPagePath } from '@lyra/web/utils/instruments'
import { useRouter } from 'next/navigation'
import React, { useCallback, useContext, useState } from 'react'

import MarketsTable from '../MarketsTable'

const MarketsDropdownSection = () => {
  const { setIsOpen } = useContext(DropdownContext)
  const [instrumentTypeFilter, setInstrumentTypeFilter] = useState<InstrumentType>()

  const router = useRouter()

  const handlePressMarket = useCallback(
    (currencyId: CurrencyId, instrumentType: InstrumentType) => {
      router.push(getInstrumentPagePath({ marketId: currencyId, type: instrumentType }))
      setIsOpen(false)
    },
    [router, setIsOpen]
  )

  return (
    <Section noTopBorder flexGrow={1} flexShrink={1} backgroundColor="$appBg">
      <Section.YStack>
        <ButtonGroup>
          <Button
            size="sm"
            label="ALL"
            isSelected={!instrumentTypeFilter}
            onPress={() => setInstrumentTypeFilter(undefined)}
          />
          <Button
            size="sm"
            label="OPTIONS"
            isSelected={instrumentTypeFilter === InstrumentType.Options}
            onPress={() => setInstrumentTypeFilter(InstrumentType.Options)}
          />
          <Button
            size="sm"
            label="PERPS"
            isSelected={instrumentTypeFilter === InstrumentType.Perps}
            onPress={() => setInstrumentTypeFilter(InstrumentType.Perps)}
          />
          <Button
            size="sm"
            label="SPOT"
            isSelected={instrumentTypeFilter === InstrumentType.Spot}
            onPress={() => setInstrumentTypeFilter(InstrumentType.Spot)}
          />
        </ButtonGroup>
      </Section.YStack>
      <Section.Table flexGrow={1} flexShrink={1}>
        <MarketsTable
          height="100%"
          instrumentType={instrumentTypeFilter}
          onPressMarket={handlePressMarket}
        />
      </Section.Table>
    </Section>
  )
}

export default MarketsDropdownSection
